import React from "react";
import { useRemoveTag } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";
import { RemoveIcon } from "./removeIcon";

function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

function intToRGB(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();
  return "00000".substring(0, 6 - c.length) + c;
}

function isColorLight(color: string) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substring(0, 2), 16);
  const c_g = parseInt(hex.substring(2, 2 + 2), 16);
  const c_b = parseInt(hex.substring(4, 4 + 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
  return brightness > 155;
}

function Tag({ tag, removable, removableId, project }: Props) {
  const { isRequestPending, removeTag } = useRemoveTag();
  const color = `#${intToRGB(hashCode(tag.name))}`;
  const textColor = isColorLight(color) ? "#000000" : "#FFFFFF";

  return (
    <div
      className={styles.tag}
      style={{ backgroundColor: color, borderColor: color }}
    >
      <p className={styles.name} style={{ color: textColor }}>
        {tag.name}
      </p>
      <div
        className={styles.removeTagIconContainer}
        onClick={() =>
          !isRequestPending &&
          removeTag({
            project,
            removable,
            removableId,
            tag,
          })
        }
      >
        <RemoveIcon className={styles.icon} />
      </div>
    </div>
  );
}

export { Tag };
